import { useState } from 'react';
import { formatarMoeda } from '../utils/formatters';
import './DashboardMock.css';

// Dados mockados para demonstração
const mockStats = {
  consultasHoje: 6,
  consultasRealizadasSemProntuario: 3,
  pagamentosPendentes: 12,
  previsaoFaturamentoMes: 15480.00,
  totalPacientes: 45,
  consultasEsteMs: 89,
  faturamentoMes: 12850.00,
  horariosLivresHoje: 4
};

const mockConsultasDia = [
  { 
    id: "1", 
    hora: "08:00", 
    pacienteNome: "Maria Silva", 
    valor: 180.00, 
    status: "Confirmada",
    temProntuario: true 
  },
  { 
    id: "2", 
    hora: "09:30", 
    pacienteNome: "João dos Santos", 
    valor: 180.00, 
    status: "Realizada",
    temProntuario: false 
  },
  { 
    id: "3", 
    hora: "14:00", 
    pacienteNome: "Ana Costa", 
    valor: 200.00, 
    status: "Confirmada",
    temProntuario: true 
  },
  { 
    id: "4", 
    hora: "15:30", 
    pacienteNome: "Carlos Oliveira", 
    valor: 180.00, 
    status: "Realizada",
    temProntuario: false 
  },
  { 
    id: "5", 
    hora: "17:00", 
    pacienteNome: "Beatriz Lima", 
    valor: 180.00, 
    status: "Agendada",
    temProntuario: true 
  },
  { 
    id: "6", 
    hora: "18:30", 
    pacienteNome: "Pedro Ferreira", 
    valor: 200.00, 
    status: "Confirmada",
    temProntuario: true 
  }
];

const mockConsultasSemana = [
  { dia: "Segunda", data: "29/09", consultas: 8, faturamento: 1440.00 },
  { dia: "Terça", data: "30/09", consultas: 6, faturamento: 1080.00 },
  { dia: "Quarta", data: "01/10", consultas: 7, faturamento: 1260.00 },
  { dia: "Quinta", data: "02/10", consultas: 5, faturamento: 900.00 },
  { dia: "Sexta", data: "03/10", consultas: 9, faturamento: 1620.00 },
  { dia: "Sábado", data: "04/10", consultas: 4, faturamento: 720.00 },
  { dia: "Domingo", data: "05/10", consultas: 2, faturamento: 360.00 }
];

const mockConsultasSemProntuario = [
  { id: "2", pacienteNome: "João dos Santos", data: "29/09/2024", hora: "09:30", valor: 180.00 },
  { id: "4", pacienteNome: "Carlos Oliveira", data: "29/09/2024", hora: "15:30", valor: 180.00 },
  { id: "7", pacienteNome: "Lucia Mendes", data: "28/09/2024", hora: "16:00", valor: 200.00 }
];

const formatarDataExibicao = (data: string): string => {
  const partes = data.split('-');
  if (partes.length === 3) {
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
  }
  return data;
};

export default function DashboardMock() {
  const [dataAtual] = useState("2024-09-29");

  return (
    <div className="dashboard-mock content-wrapper" style={{ marginLeft: 0, paddingTop: '20px' }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard - Sistema Sophya</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <span>Versão Demo</span>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          {/* Cards de Estatísticas */}
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{mockStats.consultasHoje}</h3>
                  <p>Consultas Hoje</p>
                </div>
                <div className="icon">
                  <i className="fas fa-calendar-day"></i>
                </div>
                <div className="small-box-footer">
                  {formatarDataExibicao(dataAtual)}
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>{mockStats.consultasRealizadasSemProntuario}</h3>
                  <p>Prontuários Pendentes</p>
                </div>
                <div className="icon">
                  <i className="fas fa-file-medical"></i>
                </div>
                <div className="small-box-footer">
                  Consultas sem prontuário
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-danger">
                <div className="inner">
                  <h3>{mockStats.pagamentosPendentes}</h3>
                  <p>Pagamentos Pendentes</p>
                </div>
                <div className="icon">
                  <i className="fas fa-money-bill-wave"></i>
                </div>
                <div className="small-box-footer">
                  Consultas não pagas
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="small-box bg-success">
                <div className="inner">
                  <h3>{formatarMoeda(mockStats.previsaoFaturamentoMes)}</h3>
                  <p>Previsão do Mês</p>
                </div>
                <div className="icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <div className="small-box-footer">
                  Setembro 2024
                </div>
              </div>
            </div>
          </div>

          {/* Estatísticas Adicionais */}
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="info-box">
                <span className="info-box-icon bg-primary">
                  <i className="fas fa-users"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Total de Pacientes</span>
                  <span className="info-box-number">{mockStats.totalPacientes}</span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="info-box">
                <span className="info-box-icon bg-secondary">
                  <i className="fas fa-calendar-check"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Consultas este Mês</span>
                  <span className="info-box-number">{mockStats.consultasEsteMs}</span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="info-box">
                <span className="info-box-icon bg-success">
                  <i className="fas fa-dollar-sign"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Faturamento Mês</span>
                  <span className="info-box-number">{formatarMoeda(mockStats.faturamentoMes)}</span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="info-box">
                <span className="info-box-icon bg-info">
                  <i className="fas fa-clock"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Horários Livres Hoje</span>
                  <span className="info-box-number">{mockStats.horariosLivresHoje}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Consultas do Dia */}
            <div className="col-md-8">
              <div className="card">
                <div className="card-header border-transparent">
                  <h3 className="card-title">
                    <i className="fas fa-calendar-day mr-2"></i>
                    Consultas de Hoje - {formatarDataExibicao(dataAtual)}
                  </h3>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table m-0">
                      <thead>
                        <tr>
                          <th>Horário</th>
                          <th>Paciente</th>
                          <th>Valor</th>
                          <th>Status</th>
                          <th>Prontuário</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockConsultasDia.map((consulta) => (
                          <tr key={consulta.id}>
                            <td>
                              <span className="badge badge-primary">{consulta.hora}</span>
                            </td>
                            <td>{consulta.pacienteNome}</td>
                            <td>{formatarMoeda(consulta.valor)}</td>
                            <td>
                              <span className={`badge ${
                                consulta.status === 'Realizada' ? 'badge-success' :
                                consulta.status === 'Confirmada' ? 'badge-info' :
                                'badge-secondary'
                              }`}>
                                {consulta.status}
                              </span>
                            </td>
                            <td>
                              {consulta.temProntuario ? (
                                <i className="fas fa-check-circle text-success"></i>
                              ) : (
                                <i className="fas fa-times-circle text-danger"></i>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Resumo da Semana */}
            <div className="col-md-4">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-chart-bar mr-2"></i>
                    Resumo da Semana
                  </h3>
                </div>
                <div className="card-body">
                  {mockConsultasSemana.map((dia, index) => (
                    <div key={index} className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <strong>{dia.dia}</strong>
                        <br />
                        <small className="text-muted">{dia.data}</small>
                      </div>
                      <div className="text-right">
                        <div className="text-bold">{dia.consultas} consultas</div>
                        <div className="text-success">{formatarMoeda(dia.faturamento)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Consultas sem Prontuário */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-exclamation-triangle mr-2 text-warning"></i>
                    Consultas Realizadas sem Prontuário
                  </h3>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Paciente</th>
                          <th>Data</th>
                          <th>Horário</th>
                          <th>Valor</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockConsultasSemProntuario.map((consulta) => (
                          <tr key={consulta.id}>
                            <td>{consulta.pacienteNome}</td>
                            <td>{consulta.data}</td>
                            <td>{consulta.hora}</td>
                            <td>{formatarMoeda(consulta.valor)}</td>
                            <td>
                              <button className="btn btn-sm btn-primary">
                                <i className="fas fa-edit"></i> Criar Prontuário
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}